export const SovCloudRoutes = {
    base: "/SovCloud",
    buildout: "/buildout",
    buildoutV2: "/buildoutv2",
    buildoutAutomationReport: "/buildout/automationReport",
    certificateInsights: "/certificatedashboard",
    dashboardParity: "/dashboardparity",
    deploymentTracker: "/deploymenttracker",
    monitoringParity: "/monitoringparity",
    historicalTrend: "/historicaltrend",
    accountParity: "/accountparity", // legacy separate account parity path restored
    validatonResults: "/validation",
    digitalEscort: "/digitalEscort",
    dataGuardian: "/dataGuardian",
    dataGuardianAgent: "/dataGuardian/agent/:id",
    dataGuardianRecording: "/dataGuardian/recording/:escortId",
    cloudScope: "/cloudScope",
    modelGovernance: "/modelGovernance",
    shiproomReport: "/buildoutv2/shiproom",
    gaReadinessReport: "/buildoutv2/gareadiness",
    cloudIncidents: "/buildoutv2/cloudincidents",
    adHocBuildout: "/buildoutv2/adhoc",
    getFullPathFor: (path: string) => `${SovCloudRoutes.base}${path}`
};
